import React, { useState, useContext, createRef, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { AppState } from '../../context';
import PropType from "prop-types";
import { StyledContainer } from "./styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import { Button, Tooltip, Typography, MuiAccordion, MuiAccordionSummary, MuiAccordionDetails, Container } from '@material-ui/core';
import AdminHeaderBar from './AdminHeader'
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

export default function AdminNotes() {

    const { id } = useParams();
    const [data, setData] = useState([]);

    const someContext = useContext(AppState);
    const {
        caregivers,
        familyMembers,
        seniors
    } = someContext;


    const generateData = (family) => {
        let tempData = [];

        // This is for Database reference for Caregiver ToDolist
        if (family["careBool"]) {
            Object.values(family["caregivers"]).map(caregiver => {
                if (caregivers[caregiver]["notes"] != "null") {
                    console.log(caregiver)
                    Object.values(caregivers[caregiver]["notes"]).map(note => {
                        tempData.push({
                            notetype: note["category"],
                            caregiver: caregiver["firstName"] + " " + caregiver["lastName"],
                            description: note["description"],
                            title: note["title"]
                        })
                    })
                }
            })
        }

        setData(tempData);
        return tempData;
    }


    useEffect(() => {
        if (familyMembers && caregivers && seniors) {
            generateData(familyMembers[id]);

        }
    }, [familyMembers, caregivers, seniors]);



    return (
        <div>
            {familyMembers && caregivers && seniors ?
                <div>
                    <AdminHeaderBar />
                    {data.length > 0 ?
                        <StyledContainer>
                            {data.map(input =>
                                <Accordion style={{ minWidth: 600, maxWidth: 600 }}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-label="Expand"
                                        aria-controls="additional-actions2-content"
                                        id="additional-actions2-header">
                                        <Typography>
                                            <b>{"Title: "}</b>{input.title}<b>{" Created By: "}</b>{input.caregiver}
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography color="textSecondary">
                                            {"Description: " + input.description}
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            )}
                        </StyledContainer> :
                        <StyledContainer>
                            <Typography color="textSecondary">
                                {"No notes yet"}
                            </Typography>
                        </StyledContainer>}
                </div >
                : null}
        </div>
    )
}
